export const SURVEY_CLASSIFICATION_KIND = {
  STANDARD: 'standard',
  MC: 'mc',
  GROUP_MC: 'group-mc',
  TRACKER: 'tracker',
  GROUPED: 'grouped',
} as const;

export const SURVEY_CLASSIFICATION_ROLE = {
  STANDALONE: 'standalone',
  PARENT: 'parent',
  CHILD: 'child',
} as const;
